import React, { useState } from "react";

// Modal Component
const Modal = ({ isOpen, onClose, title, message, type = "info" }) => {
  if (!isOpen) return null;

  const getIconColor = () => {
    switch (type) {
      case "success": return "text-green-500";
      case "error": return "text-red-500";
      default: return "text-blue-500";
    }
  };

  const getIcon = () => {
    switch (type) {
      case "success":
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        );
      case "error":
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        );
      default:
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        );
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex items-center mb-4">
          <div className={`${getIconColor()} mr-3`}>
            {getIcon()}
          </div>
          <h3 className="text-lg font-semibold text-gray-900 font-raleway">
            {title}
          </h3>
        </div>
        <p className="text-gray-600 mb-6 font-raleway">
          {message}
        </p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="bg-[#85C4FF] text-black px-6 py-2 rounded-lg font-raleway font-medium hover:bg-[#75B4EF] transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default function ContactSection() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState({ isOpen: false, title: "", message: "", type: "info" });

  const showModal = (title, message, type = "info") => {
    setModal({ isOpen: true, title, message, type });
  };

  const closeModal = () => {
    setModal({ isOpen: false, title: "", message: "", type: "info" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validação básica do email
    if (!email) {
      showModal("Campo obrigatório", "Por favor, insira seu email!", "error");
      return;
    }

    if (!email.includes("@") || !email.includes(".")) {
      showModal("Email inválido", "Por favor, insira um email válido!", "error");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/api/contato`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nome: "Contato via Landing Page",
          email: email,
          contato: "",
          empresa: "",
          organizacao: "Landing Page",
          mensagem: "Solicitação de contato via seção 'Vamos conversar?' da landing page",
          privacidade: true,
        }),
      });

      if (response.ok) {
        showModal("Sucesso!", "Email cadastrado com sucesso! Entraremos em contato em breve.", "success");
        setEmail("");
      } else {
        showModal("Erro", "Erro ao cadastrar email. Tente novamente.", "error");
      }
    } catch (error) {
      console.error("Erro ao enviar email:", error);
      showModal("Erro", "Erro ao cadastrar email. Verifique sua conexão e tente novamente.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="bg-[#002342] py-16 flex items-center justify-center px-4 sm:px-6 md:px-8 lg:px-12 xl:px-[175px]">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="max-w-[490px]">
            <h2 className="font-bauhaus font-bold text-2xl md:text-[42px] leading-tight md:leading-[46px] text-white mb-2 md:mb-[3px]">
              Vamos conversar?
            </h2>
            <p className="font-raleway text-[16px] md:text-[20px] leading-tight md:leading-[24px] text-white">
              Você pode agendar uma call com nosso time comercial ou acessar o portfólio institucional via login.
            </p>
          </div>
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 md:gap-[20px] w-full lg:w-auto align-bottom">
            <input
              type="email"
              placeholder="name@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              className="w-full sm:w-[200px] md:w-[273px] h-[40px] md:h-[50px] rounded-[25px] md:rounded-[99px] border border-gray-200 px-4 md:px-[16px] font-raleway text-[14px] md:text-[16px] text-[#888888] bg-white disabled:opacity-50"
            />
            <button
              type="submit"
              disabled={isLoading}
              className="bg-[#85C4FF] text-black px-4 md:px-[15px] py-3 md:py-[14px] rounded-[25px] md:rounded-[99px] font-raleway font-bold text-[16px] md:text-[20px] hover:bg-white transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? "Enviando..." : "Cadastre-se"}
            </button>
          </form>
        </div>
      </section>

      {/* Modal */}
      <Modal
        isOpen={modal.isOpen}
        onClose={closeModal}
        title={modal.title}
        message={modal.message}
        type={modal.type}
      />
    </>
  );
}
